import { ReactNode } from 'react';
import { fetchHeaderFooterForLayout } from '../../../lib/serverFetch';

export default async function PayLayout({
  children,
}: {
  children: ReactNode;
}) {
  // Fetch footer data on the server side
  let headerFooterData;
  try {
    headerFooterData = await fetchHeaderFooterForLayout();
  } catch (error) {
    headerFooterData = null;
  }

  return (
    <div>
      {children}
    </div>
  );
}
